import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { JsonLd } from "@/components/JsonLd";
import { AdSlot } from "@/components/AdSlot";
import { Card } from "@/components/ui/card";
import TeppichRechner from "@/components/teppich/TeppichRechner";
import { TEPPICH_SEITEN, HUB_SEITE } from "@/lib/teppichSeiten";

export default function TeppichHubPage() {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const canonical = origin ? `${origin}/${HUB_SEITE.slug}` : undefined;

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "Teppichgrößen-Rechner",
      url: canonical,
      applicationCategory: "UtilityApplication",
      operatingSystem: "Web",
      offers: { "@type": "Offer", price: "0", priceCurrency: "EUR" },
      inLanguage: "de-DE",
    },
  ];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
      <Seo title={HUB_SEITE.title} description={HUB_SEITE.description} canonical={canonical} />
      <JsonLd data={jsonLd} />

      <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">{HUB_SEITE.h1}</h1>
      <p className="mt-3 text-muted-foreground leading-relaxed">
        Wähle den Fall, gib deine Maße ein und du bekommst sofort die passende Teppichgröße samt nächster handelsüblicher Standardgröße. Alles im Browser, kostenlos und ohne Anmeldung.
      </p>

      <div className="mt-6">
        <TeppichRechner fall="esstisch" />
      </div>

      <div className="mt-8"><AdSlot variant="banner" /></div>

      <section className="mt-8">
        <h2 className="text-xl font-semibold mb-3">Direkt zum passenden Fall</h2>
        <div className="grid sm:grid-cols-2 gap-3">
          {TEPPICH_SEITEN.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} className="block">
              <Card className="p-4 h-full hover:shadow-md transition-shadow">
                <div className="font-semibold text-sm">{s.h1}</div>
                <div className="text-sm text-muted-foreground mt-1">{s.description}</div>
              </Card>
            </Link>
          ))}
        </div>
        <p className="mt-4 text-sm">
          <Link to="/teppich-groessentabelle" className="text-primary hover:underline">
            Alle Teppich Standardmaße in der Größentabelle
          </Link>
        </p>
      </section>

      <div className="mt-10"><AdSlot variant="banner" /></div>
    </div>
  );
}
